import createFetchClient, { type ClientOptions } from 'openapi-fetch'
import createRQClient from 'openapi-react-query'
import type { paths } from '../../types.agent.d.ts'

/**
 * Creates a React Query client that talks to the Netdata Agent API.
 * Quick start:
 *   const rqClient = createAgentQueryClient({ baseUrl: "http://localhost:19999" });
 *   const { data } = rqClient.useQuery("get", "/api/v3/nodes");
 */
export default function createAgentQueryClient(options: ClientOptions = {}) {
    const fetchClient = createFetchClient<paths>(options)

    return createRQClient(fetchClient)
}
